import "../css/extended.scss";
import {projectsGallery} from "./projects/projectsGallery";

'use strict';
(function (window, document) {
    window.addEventListener('DOMContentLoaded', (event) => {
        const projectsGallerySelector = '.js-projects-gallery';
        const hasProjectsGallery = document.querySelector(projectsGallerySelector) !== null;
        console.log(document.querySelector(projectsGallerySelector));
        console.log(hasProjectsGallery);
        if (hasProjectsGallery) {
            projectsGallery(projectsGallerySelector);
        }
    });
})(window, document);